import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import { EditOutlined, CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItem, TourItem } from "../../../../Components/Items";
import { cmmsPost, OPCIONES_ESTADO } from "../cmmsComun";
import ModalTipoActivo from "./ModalTipoActivo";


// Listado de Tipos de Activo del CMMS (Ventilador, Desfibrilador...). Es la base para
// agrupar los activos y de donde heredan su configuracion.
class TiposActivo extends Component {
    refTabla = React.createRef();

    state = {
        loading: false,
        tipos: [],
        valor: 1,
        modalTipo: false,
        modoModal: "agregar",
        tipoId: null,
        openTour: false,
    };

    componentDidMount() {
        this.consultarTipos();
    }

    consultarTipos = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "selectTiposEquipo", { valor: this.state.valor });
            this.setState({ tipos: res.data.success === 2 ? res.data.tipos : [] });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar los tipos de activo");
        } finally {
            this.setState({ loading: false });
        }
    };

    cambiarEstado = async (id, estado) => {
        try {
            const res = await cmmsPost(this.props, "cambiarEstadoTipoEquipo", { id, estado });
            if (res.data.success === 2) {
                message.success(estado === 1 ? "Tipo de activo habilitado" : "Tipo de activo deshabilitado");
                this.consultarTipos();
            } else {
                message.error(res.data.message || "No se pudo cambiar el estado");
            }
        } catch (error) {
            console.log(error);
            message.error("No se pudo cambiar el estado");
        }
    };

    abrirAgregar = () => this.setState({ modalTipo: true, modoModal: "agregar", tipoId: null });
    abrirEditar = (id) => this.setState({ modalTipo: true, modoModal: "editar", tipoId: id });
    cerrarModalTipo = () => this.setState({ modalTipo: false }, this.consultarTipos);
    render() {
        const columns = [
            { title: "Clave", dataIndex: "clave", key: "clave", buscar: "clave", width: "10%" },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                sorter: (a, b) => (a.nombre || "").localeCompare(b.nombre || ""),
                width: "26%",
            },
            {
                title: "Preventivo cada",
                dataIndex: "periodicidadMeses",
                key: "periodicidadMeses",
                width: "12%",
                render: (value) => (value ? `${value} ${value === 1 ? "mes" : "meses"}` : ""),
            },
            {
                title: "Tiempo estimado",
                dataIndex: "duracionEstimadaMin",
                key: "duracionEstimadaMin",
                width: "12%",
                render: (value) => (value ? `${value} min` : ""),
            },
            {
                title: "Seg. eléctrica",
                dataIndex: "requiereSeguridadElectrica",
                key: "requiereSeguridadElectrica",
                width: "10%",
                render: (value) => (value ? "Sí" : ""),
            },
            {
                title: "Activos",
                dataIndex: "totalActivos",
                key: "totalActivos",
                width: "8%",
                sorter: (a, b) => (a.totalActivos || 0) - (b.totalActivos || 0),
            },
            {
                title: "Acción",
                key: "acciones",
                fixed: "right",
                align: "center",
                width: 110,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (value) => {
                    const buttons = [];
                    buttons.push(
                        <Tooltip title="Editar" placement="top" key="editar">
                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrirEditar(value._id)} />
                        </Tooltip>
                    );
                    if (value.estado === 1) {
                        buttons.push(
                            <Popconfirm key="deshabilitar" title="¿Deshabilitar este tipo de activo?" onConfirm={() => this.cambiarEstado(value._id, 2)} okText="Sí" cancelText="No">
                                <Tooltip title="Deshabilitar">
                                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm key="habilitar" title="¿Habilitar este tipo de activo?" onConfirm={() => this.cambiarEstado(value._id, 1)} okText="Sí" cancelText="No">
                                <Tooltip title="Habilitar">
                                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                                </Tooltip>
                            </Popconfirm>
                        );
                    }
                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        return (
            <>
                <PageHeader
                    title="Tipos de Activo"
                    subTitle="Mantenimiento"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            {window.innerWidth > 1000 && (
                                <SegmentedItem
                                    options={OPCIONES_ESTADO}
                                    value={this.state.valor}
                                    onChange={(valor) => this.setState({ valor }, this.consultarTipos)}
                                />
                            )}
                            <ButtonItem type="primary" olivo className="botonAgregar" onClick={this.abrirAgregar}>
                                Agregar Tipo de Activo
                            </ButtonItem>
                            <ButtonItem type="link" blanco onClick={() => this.setState({ openTour: true })}>
                                ¿Cómo funciona?
                            </ButtonItem>
                        </>
                    }
                />
                <div ref={this.refTabla}>
                    <TableItem
                        loading={this.state.loading}
                        size="small"
                        dataSource={this.state.tipos}
                        columns={columns}
                        pagination={true}
                        onRow={(record) => ({ onDoubleClick: () => this.abrirEditar(record._id) })}
                    />
                </div>

                <ModalTipoActivo
                    visible={this.state.modalTipo}
                    modo={this.state.modoModal}
                    tipoId={this.state.tipoId}
                    onClose={this.cerrarModalTipo}
                />

                <TourItem
                    open={this.state.openTour}
                    onClose={() => this.setState({ openTour: false })}
                    steps={[
                        {
                            title: "Tipos de Activo",
                            description:
                                "Es el listado de tipos de equipo médico (Ventilador mecánico, Desfibrilador, Monitor de signos vitales...). Cada activo pertenece a un tipo y hereda de él su periodicidad de preventivo, tiempo estimado, rutina y kit de refacciones. Los certificados que se proponen para cada tipo se eligen en CMMS › Certificados › Plantillas.",
                            target: null,
                        },
                        {
                            title: "Listado",
                            description:
                                "La columna Activos indica cuántos equipos activos hay de cada tipo. Doble clic en un renglón para editarlo. Un tipo con activos no se puede deshabilitar.",
                            target: () => this.refTabla.current,
                        },
                    ]}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(TiposActivo);
